<template>
    <div id="dashboard">

      <transition name="fade-bottom">

        <div class="router-header flex flex-wrap items-center mb-6">
          <div
            class="content-area__heading">
            <h2 class="mb-1">Dashboard</h2>
          </div>

          <!-- DROPDOWN -->
          <div class="ml-auto md:block hidden cursor-pointer">
            <div class="vx-row">
              <div class="mr-2">
                <flat-pickr class="shadow-drop no-border" :config="configFromdateTimePicker" v-model="fromDate" placeholder="From Date" @on-change="onFromChange" />
              </div>
              <div>
                <flat-pickr class="shadow-drop no-border" :config="configTodateTimePicker" v-model="toDate" placeholder="To Date" @on-change="onToChange" />
              </div>
            </div>
          </div>

        </div>
      </transition>

        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="BookIcon"
                  icon-right
                  :statistic="debit"
                  :statisticTitle="$t('CashIn')"
                  color="success" />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  icon-right
                  :statistic="`${ totalDebit.toLocaleString() }`"
                  :statisticTitle="$t('TotalCashIn')"
                  color="success" />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="BookIcon"
                  icon-right
                  :statistic="credit"
                  :statisticTitle="$t('CashOut')"
                  color="danger" />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  icon-right
                  :statistic="`${ totalCredit.toLocaleString() }`"
                  :statisticTitle="$t('TotalCashOut')"
                  color="danger" />
            </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vx-card title="Grafik Buku Kas" class="">
              <vue-apex-charts type="area" height="350" :options="cashBooks.chartOptions" :series="cashBooks.series"></vue-apex-charts>
            </vx-card>
          </div>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import 'flatpickr/dist/flatpickr.css'

// Store Module
import moduleDashboard from '@/store/dashboard/moduleDashboard.js'

export default{
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    flatPickr
  },
  data () {
    return {
      checkpointReward: {},

      debit: 0,
      credit: 0,
      totalDebit: 0,
      totalCredit: 0,


      cashBooks: {
        series: [],
        chartOptions: {
          colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          stroke: {
            curve: 'smooth'
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy'
            }
          }
        }
      },

      fromDate: moment(String(new Date(new Date().getFullYear(), new Date().getMonth(), 1))).format('DD-MM-YYYY'),
      toDate: moment(String(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))).format('DD-MM-YYYY'),
      configFromdateTimePicker: {
        dateFormat: 'd-m-Y',
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        dateFormat: 'd-m-Y',
        minDate: null,
        maxDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      }
    }
  },
  methods: {
    getColor (id) {
      if (this.categoryActive !== id) {
        return 'primary'
      } else {
        return 'success'
      }
    },
    onFromChange (selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr)
      this.getTotalStatistics()
      this.getCashbooks()
    },
    onToChange (selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
      this.getTotalStatistics()
      this.getCashbooks()
    },
    getTotalStatistics () {
      const self        = this
      const userData  = this.$store.state.AppActiveUser

      this.$store.dispatch(
        'dashboard/getTotalStatistics', {
          companyID: userData.company.id,
          startDate: self.fromDate,
          endDate: self.toDate
        }
      )
        .then(res => {
          const data        = res.data.data
          self.debit        = data.debit.items
          self.totalDebit   = (data.debit.amount === null) ? 0 : data.debit.amount
          self.credit       = data.credit.items
          self.totalCredit  = (data.credit.amount === null) ? 0 : data.credit.amount
        })
        .catch(err => {
          self.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err.response.data.message
          })
        })
    },
    getCashbooks () {
      const self        = this
      const userData  = this.$store.state.AppActiveUser

      this.$store.dispatch(
        'dashboard/getCashbooks', {
          companyID: userData.company.id,
          startDate: self.fromDate,
          endDate: self.toDate
        }
      )
        .then(res => {
          const data = res.data.data

          self.cashBooks.chartOptions = {
            colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
            stroke: {
              curve: 'smooth'
            },
            dataLabels: {
              enabled: false
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy'
              }
            },
            xaxis: {
              categories: data.categories
            }
          }

          self.cashBooks.series = data.series
        })
        .catch(err => {
          self.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err.response.data.message
          })
        })
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  created () {
    // Register Module Dashboard Module
    if (!moduleDashboard.isRegistered) {
      this.$store.registerModule('dashboard', moduleDashboard)
      moduleDashboard.isRegistered = true
    }
    this.getTotalStatistics()
    this.getCashbooks()
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}

.chat-card-log {
    height: 400px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;
    }
}
</style>
